import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App.tsx";
import PrivacyPolicy from "./components/PrivacyPolicyPage.tsx";
import TermsOfService from "./components/TermsOfServicePage.tsx";
import FAQ from "./components/FaqPage.tsx";
import ContactUsPage from "./components/ContactUsPage.tsx";
import DeleteAccountPage from "./components/DeleteAccountPage.tsx";
import "./index.css";

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// App wrapper with error boundary and Helmet provider
function AppWrapper() {
  return (
    <StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
            {/* Catch-all route */}
            <Route path="*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </StrictMode>
  );
}

// Register service worker. Production only: the dev server no longer emits
// /sw.js, so registering there just 404s into index.html and logs a MIME error.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(registration => {
        console.log('SW registered:', registration);
      })
      .catch(error => {
        console.log('SW registration failed:', error);
      });
  });
}

// Mount the app
createRoot(document.getElementById("root")!).render(<AppWrapper />);
